module.exports = __webpack_public_path__ + "static/media/ranking_icon.32a42f69.png";